import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import {
  openErrorOrWarningDialog,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  EditProductTableSuccess,
} from "../../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  MEDIUM_NUTRITION_DOWNLOAD_OPE_CPT_TABLE_API,
  MEDIUM_NUTRITION_VIEW_OPE_CPT_TABLE_API,
  NEW_BUILK_EDIT_MEDIUM_NUTRITION_EDIT_OPE_CPT_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import OEEAndCPTTables from "./OEEAndCPTTables";
import btnDownloadIcon from ".././../../Assests/download.svg";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import axios from "axios";
import FileSaver from "file-saver";
import * as actions from "../../../Redux/Actions/index";
import ErrorOrWarningDialog from "../../../Components/Modals/ErrorOrWarningDialog";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import btnSaveIcon from "../../../Assests/Save-btn.svg";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

let setEmptyTimeCall = false;
let restoreFlag = false;

function MediumManufactureOPEAndCPTInputs(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectProduct, setSelectProduct] = useState<any>("");

  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [selectCapacity, setSelectCapacity] = useState<any>("");
  const [selectRMPMDescription, setSelectRMPMDescription] = useState("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [productOptions, setProductOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [capacityOptions, setCapacityOptions] = useState<any>([]);
  const [descriptionOptions, setDescriptionOptions] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key": "Factory_Name", "value": ""}, {"key": "RM_PM_Description", "value": ""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "line", value: "" },
    { key: "product", value: "" },
    { key: "time_Period", value: "" },
    { key: "additionalCapacity", value: "" },
  ]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const {
    isErrorDialog,
    errorMessage,
    isErrorOrWarningDialog,
    errorOrWarningMessage,
  } = useSelector((state: any) => state.InputDataReducers);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var fact = 0;
  var product = 0;
  var time = 0;
  var additionalCapacity = 0;
  /**Redux state */
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
      //setPageIsLoaded(true);
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase, category and folder.",
        ),
      );
    } else {
      //setPageIsLoaded(false);
    }
    // callTableGridApi();
  }, []);

  useEffect(() => {
    callTableGridApi();
    // if (selectedUsecaseId === 2 && selectedCategoryId === 2) {
    // }
    getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);

  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";

    let filterList: any = [];
    if (!restoreFlag) {
      filterList = filterRequest.filter((elem: any) => {
        if (
          elem.key == "time_period" &&
          elem.value == "-" &&
          setEmptyTimeCall
        ) {
          return elem;
        } else {
          return elem.value != "";
        }
      });
    }
    console.log(filterList, "list data");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionManufacturingOPEandCPT"
          : "tblScenario_NutritionManufacturingMasterandOPE_Add_MT",
      time_period: timePeriodValues,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_VIEW_OPE_CPT_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "sunny");

          setIsProcessed(true);
          restoreFlag = false;
          setRows(response.data);
          console.log(response.data, "response data");

          if (fact === 0) {
            setFactoryOptions(actions.loadFactoryOptions(response.data));
          }
          setLineOptions(actions.loadLineOptions(response.data));
          setBasepackOptions(actions.loadBasePackOptions(response.data));
          if (product === 0)
            setProductOptions(actions.loadProductOptions(response.data));

          if (time === 0) {
            setTimePeriodOptions(loadTimePeriodOptions(response.data));
          }
          if (additionalCapacity === 0) {
            setCapacityOptions(loadCapacityOptions(response.data));
          }
          // loadFactoryOptions(response.data);
          // loadLineOptions(response.data);
          // loadBasePackOptions(response.data);
          // loadTimePeriodOptions(response.data);
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.factory_Name === item.factory;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, factory_Name: item.factory });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadLineOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.line === item.line;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, line: item.line });
      }
    });
    setLineOptions(lineOptions);
  };

  const loadBasePackOptions = (data: any) => {
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.basepack === item.basepack;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, basepack: item.basepack });
      }
    });
    setBasepackOptions(basePackOptions);
  };

  const loadTimePeriodOptions = (data: any) => {
    console.log(data, "datamediucm");
    const timePeriodPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodPackOptions?.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodPackOptions?.push({
          id: item.id,
          time_Period: item.time_Period,
        });
      }
    });

    const newState = timePeriodPackOptions.map((obj: any) =>
      obj.time_Period == null ? { ...obj, time_Period: "-" } : obj,
    );

    // Declare a new array
    let newArray = [];

    // Declare an empty object
    let uniqueObject: any = {};

    // Loop for the array elements
    for (let i in newState) {
      // Extract the title
      let objTitle = newState[i]["time_Period"];

      // Use the title as the index
      uniqueObject[objTitle] = newState[i];
    }

    // Loop to push unique object into array
    let i;
    for (i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }

    return newArray;
  };

  const loadCapacityOptions = (data: any) => {
    console.log(data, "data");
    //console.log(capacityOptions, "capacityOptionssss")
    const capacityPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = capacityPackOptions.find((obj: any) => {
        return obj.additionalCapacity === item.additionalCapacity;
      });
      if (filteredItem === undefined || filteredItem == null) {
        capacityPackOptions.push({
          id: item.id,
          additionalCapacity: item.additionalCapacity,
        });
      }
    });
    return capacityPackOptions;
    //setTimePeriodOptions(timePeriodPackOptions);
  };
  console.log(capacityOptions, "capacityOptionssss");

  const loadProductOptions = (data: any) => {
    const productOptions: any = [];
    data.map((item: any) => {
      const filteredItem = productOptions.find((obj: any) => {
        return obj.product === item.product;
      });
      if (filteredItem === undefined || filteredItem == null) {
        productOptions.push({ id: item.id, option: item.product });
      }
    });
    setProductOptions(productOptions);
  };

  const getfiltersApi = () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;

    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionManufacturingOPEandCPT"
          : "tblScenario_NutritionManufacturingMasterandOPE_Add_MT",
      time_period: "",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_VIEW_OPE_CPT_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          // setFactoryOptions(response.data.factory_NameFilter);
          // setTimePeriodOptions(response.data.time_PeriodFilter);
          setDescriptionOptions(response.data.rM_PM_DescriptionFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleChangeSelectFactory = (event: any) => {
    fact = 1;
    product = 0;
    time = 0;
    additionalCapacity = 0;
    setSelectTimePeriod("");
    setSelectCapacity("");
    setSelectProduct("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    console.log(value, "factory filter");
    //  filterRequest.push(value);
    filterRequest[0].value = value;
    callTableGridApi();
  };

  // const handleChangeSelectDescription = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectRMPMDescription(value);
  //   callTableGridApi();
  // };

  const handleChangeSelectLine = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[1].value = value;
    callTableGridApi();
  };

  // const handleChangeSelectBasepack = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectBasepack(value);
  //   filterRequest[2].value = value
  //   callTableGridApi();
  // };

  const handleChangeSelectProduct = (event: any) => {
    fact = 1;
    product = 1;
    time = 0;
    additionalCapacity = 0;
    setSelectTimePeriod("");
    setSelectCapacity("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectProduct(value);
    filterRequest[2].value = value;
    callTableGridApi();
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    fact = 1;
    time = 1;
    product = 1;
    additionalCapacity = 1;
    setEmptyTimeCall = false;
    const {
      target: { value },
    } = event;
    let userVal;
    userVal = value;
    if (value == "-") {
      userVal = "-";
      setEmptyTimeCall = true;
    }
    setSelectTimePeriod(userVal);
    filterRequest[3].value = userVal;
    callTableGridApi();
  };

  const handleChangeSelectCapacity = (event: any) => {
    fact = 1;
    product = 1;
    additionalCapacity = 1;
    time = 0;
    setEmptyTimeCall = false;
    const {
      target: { value },
    } = event;

    setSelectTimePeriod("");
    filterRequest[3].value = "";

    setSelectCapacity(value);
    filterRequest[4].value = value;
    callTableGridApi();
  };

  const handleRestoreClicked = (e: any) => {
    restoreFlag = true;
    setEmptyTimeCall = false;
    setSelectFactory("");
    setSelectProduct("");
    setSelectTimePeriod("");
    setSelectCapacity("");
    setFilterRequest([
      { key: "factory", value: "" },
      { key: "line", value: "" },
      { key: "product", value: "" },
      { key: "time_Period", value: "" },
      { key: "additionalCapacity", value: "" },
    ]);
    filterRequest.filter((element) => element.value != "");
    // getfiltersApi();
    callTableGridApi([]);
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        factory_Code: "",
        factory: "",
        format: "",
        cascade: "",
        product: "",
        time_Period: "",
        ope: 0.0,
        conversion_Cost_per_Tonne: 0,
        processing_Time: "",
        additionalCapacity: "",
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    let filterList: any = [];
    if (!restoreFlag) {
      filterList = filterRequest.filter((elem: any) => {
        if (
          elem.key == "time_period" &&
          elem.value == "-" &&
          setEmptyTimeCall
        ) {
          return elem;
        } else {
          return elem.value != "";
        }
      });
    }

    //const filterList = filterRequest.filter((elem: any) => elem.value != '');
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        scenarioId === 0
          ? "tblNutritionManufacturingOPEandCPT"
          : "tblScenario_NutritionManufacturingMasterandOPE_Add_MT",
      time_period: timePeriodValues,
      filter: filterList,
    };
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DOWNLOAD_OPE_CPT_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      restoreFlag = false;
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  console.log("selectCapacity", selectCapacity);

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "format",
      "cascade",
      "product",
      "time_Period",
      "ope",
      "conversion_Cost_per_Tonne",
      "processing_Time",
      "additionalCapacity",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        rest.usecaseId = selectedUsecaseId;
        rest.category_Id = selectedCategoryId;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      API_BASE_URL + NEW_BUILK_EDIT_MEDIUM_NUTRITION_EDIT_OPE_CPT_TABLE_API;
    const ScenarioId = selectedScenarioId;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, { ScenarioId })
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited OEE&CPT table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="OEE and CPT"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
          isErrorOrWarningDialog={isErrorOrWarningDialog}
          errorOrWarningMessage={errorOrWarningMessage}
        />
      )}

      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Manufacturing OPE & CPT</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
                titleAccess="Reset"
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {factoryOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
             <FormControl fullWidth className="selectDropdown">
               <InputLabel>Line</InputLabel>
               <Select
                 id="simple-select-3"
                 value={selectLine}
                 placeholder="Select Line"
                 onChange={handleChangeSelectLine}
                 renderValue={(selectLine: any) => selectLine}
                 className="select-short-term">
                 {lineOptions?.map((d: any) => {
                   return (<MenuItem key={d} value={d.line}>{d.line}</MenuItem>)
                 })}
               </Select>
             </FormControl>
           </div> */}
            {/* <div className="filter-item">
             <FormControl fullWidth className="selectDropdown">
               <InputLabel>Basepack</InputLabel>
               <Select
                 id="simple-select-4"
                 value={selectBasepack}
                 placeholder="Select Basepack"
                 onChange={handleChangeSelectBasepack}
                 renderValue={(selectBasepack: any) => selectBasepack}
                 className="select-short-term">
                 {basepackOptions.map((d: any) => {
                   return (<MenuItem key={d} value={d.basepack}>{d.basepack}</MenuItem>)
                 })}
               </Select>
             </FormControl>
           </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Product</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectProduct}
                  placeholder="Select Product"
                  onChange={handleChangeSelectProduct}
                  //  renderValue={(selectProduct: any) => selectProduct}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Product</em>
                  </MenuItem>
                  {productOptions.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.product}>
                        {d.product}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {selectedScenarioId > 0 ? (
              <div className="filter-item">
                <FormControl fullWidth className="selectDropdown">
                  {/* <InputLabel>Capacity</InputLabel> */}
                  <Select
                    id="simple-select-4"
                    value={selectCapacity}
                    placeholder="Select Capacity"
                    onChange={handleChangeSelectCapacity}
                    //  renderValue={(selectCapacity: any) => selectCapacity}
                    className="select-short-term"
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Capacity</em>
                    </MenuItem>

                    {capacityOptions?.map((d: any) => {
                      return (
                        <MenuItem key={d} value={d.additionalCapacity}>
                          {d.additionalCapacity}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            ) : (
              ""
            )}

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>TimePeriod</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectTimePeriod}
                  placeholder="Select TimePeriod"
                  onChange={handleChangeSelectTimePeriod}
                  //renderValue={(selectTimeperiod: any) => selectTimeperiod}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>TimePeriod</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>

      <div>
        <OEEAndCPTTables
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          ref={childRef}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default MediumManufactureOPEAndCPTInputs;
